export const INSTALLATION_TYPES = {
  CLOUD: 'cloud',
  ENTERPRISE: 'enterprise',
  COMMUNITY: 'community',
};
